var Base = function () {};
(Base.extend = function (s, t) {
  "use strict";
  var i = Base.prototype.extend;
  Base._prototyping = !0;
  var e = new this();
  i.call(e, s), (e.base = function () {}), delete Base._prototyping;
  var a = e.constructor,
    n = (e.constructor = function () {
      if (!Base._prototyping) {
        if (this._constructing || this.constructor == n)
          (this._constructing = !0),
            a.apply(this, arguments),
            delete this._constructing;
        else if (arguments[0] !== null)
          return (arguments[0].extend || i).call(arguments[0], e);
      }
    });
  return (
    (n.ancestor = this),
    (n.extend = this.extend),
    (n.forEach = this.forEach),
    (n.implement = this.implement),
    (n.prototype = e),
    (n.toString = this.toString),
    (n.valueOf = function (r) {
      return r == "object" ? n : a.valueOf();
    }),
    i.call(n, t),
    typeof n.init == "function" && n.init(),
    n
  );
}),
  (Base.prototype = {
    extend: function (s, t) {
      if (arguments.length > 1) {
        var i = this[s];
        if (
          i &&
          typeof t == "function" &&
          (!i.valueOf || i.valueOf() != t.valueOf()) &&
          /\bbase\b/.test(t)
        ) {
          var e = t.valueOf();
          (t = function () {
            var c = this.base || Base.prototype.base;
            this.base = i;
            var h = e.apply(this, arguments);
            return (this.base = c), h;
          }),
            (t.valueOf = function (c) {
              return c == "object" ? t : e;
            }),
            (t.toString = Base.toString);
        }
        this[s] = t;
      } else if (s) {
        var a = Base.prototype.extend;
        !Base._prototyping &&
          typeof this != "function" &&
          (a = this.extend || a);
        for (
          var n = { toSource: null },
            r = ["constructor", "toString", "valueOf"],
            u = Base._prototyping ? 0 : 1;
          (o = r[u++]);

        )
          s[o] != n[o] && a.call(this, o, s[o]);
        for (var o in s) n[o] || a.call(this, o, s[o]);
      }
      return this;
    }
  }),
  (Base = Base.extend(
    {
      constructor: function () {
        this.extend(arguments[0]);
      }
    },
    {
      ancestor: Object,
      version: "1.1",
      forEach: function (s, t, i) {
        for (var e in s) this.prototype[e] === void 0 && t.call(i, s[e], e, s);
      },
      implement: function () {
        for (var s = 0; s < arguments.length; s++)
          typeof arguments[s] == "function"
            ? arguments[s](this.prototype)
            : this.prototype.extend(arguments[s]);
        return this;
      },
      toString: function () {
        return String(this.valueOf());
      }
    }
  ));
var FlipClock;
(function (s) {
  "use strict";
  (FlipClock = function (t, i, e) {
    return (
      i instanceof Object && !(i instanceof Date) && ((e = i), (i = 0)),
      new FlipClock.Factory(t, i, e)
    );
  }),
    (FlipClock.Lang = {}),
    (FlipClock.Base = Base.extend({
      buildDate: "2014-12-12",
      version: "0.7.7",
      constructor: function (t, i) {
        typeof t != "object" && (t = {}),
          typeof i != "object" && (i = {}),
          this.setOptions(s.extend(!0, {}, t, i));
      },
      callback: function (t) {
        if (typeof t == "function") {
          for (var i = [], e = 1; e <= arguments.length; e++)
            arguments[e] && i.push(arguments[e]);
          t.apply(this, i);
        }
      },
      log: function (t) {
        window.console && console.log && console.log(t);
      },
      getOption: function (t) {
        return this[t] ? this[t] : !1;
      },
      getOptions: function () {
        return this;
      },
      setOption: function (t, i) {
        this[t] = i;
      },
      setOptions: function (t) {
        for (var i in t) typeof t[i] != "undefined" && this.setOption(i, t[i]);
      }
    }));
})(jQuery),
  (function (s) {
    "use strict";
    FlipClock.Face = FlipClock.Base.extend({
      autoStart: !0,
      dividers: [],
      factory: !1,
      lists: [],
      constructor: function (t, i) {
        (this.dividers = []),
          (this.lists = []),
          this.base(i),
          (this.factory = t);
      },
      build: function () {
        this.autoStart && this.start();
      },
      createDivider: function (t, i, e) {
        (typeof i == "boolean" || !i) && ((e = i), (i = t));
        var a = [
          '<span class="' + this.factory.classes.dot + ' top"></span>',
          '<span class="' + this.factory.classes.dot + ' bottom"></span>'
        ].join("");
        e && (a = ""), (t = this.factory.localize(t));
        var n = [
            '<span class="' +
              this.factory.classes.divider +
              " " +
              (i || "").toLowerCase() +
              '">',
            '<span class="' +
              this.factory.classes.label +
              '">' +
              (t || "") +
              "</span>",
            a,
            "</span>"
          ],
          r = s(n.join(""));
        return this.dividers.push(r), r;
      },
      createList: function (t, i) {
        typeof t == "object" && ((i = t), (t = 0));
        var e = new FlipClock.List(this.factory, t, i);
        return this.lists.push(e), e;
      },
      reset: function () {
        (this.factory.time = new FlipClock.Time(
          this.factory,
          this.factory.original ? Math.round(this.factory.original) : 0,
          { minimumDigits: this.factory.minimumDigits }
        )),
          this.flip(this.factory.original, !1);
      },
      appendDigitToClock: function (t) {
        t.$el.append(!1);
      },
      addDigit: function (t) {
        var i = this.createList(t, {
          classes: {
            active: this.factory.classes.active,
            before: this.factory.classes.before,
            flip: this.factory.classes.flip
          }
        });
        this.appendDigitToClock(i);
      },
      start: function () {},
      stop: function () {},
      autoIncrement: function () {
        this.factory.countdown ? this.decrement() : this.increment();
      },
      increment: function () {
        this.factory.time.addSecond();
      },
      decrement: function () {
        this.factory.time.getTimeSeconds() == 0
          ? this.factory.stop()
          : this.factory.time.subSecond();
      },
      flip: function (t, i) {
        var e = this;
        s.each(t, function (a, n) {
          var r = e.lists[a];
          r ? (!i && n != r.digit && r.play(), r.select(n)) : e.addDigit(n);
        });
      }
    });
  })(jQuery),
  (function (s) {
    "use strict";
    FlipClock.Factory = FlipClock.Base.extend({
      animationRate: 1e3,
      autoStart: !0,
      callbacks: {
        destroy: !1,
        create: !1,
        init: !1,
        interval: !1,
        start: !1,
        stop: !1,
        reset: !1
      },
      classes: {
        active: "flip-clock-active",
        before: "flip-clock-before",
        divider: "flip-clock-divider",
        dot: "flip-clock-dot",
        label: "flip-clock-label",
        flip: "flip",
        play: "play",
        wrapper: "flip-clock-wrapper"
      },
      clockFace: "HourlyCounter",
      countdown: !1,
      defaultClockFace: "HourlyCounter",
      defaultLanguage: "english",
      $el: !1,
      face: !0,
      lang: !1,
      language: "english",
      minimumDigits: 0,
      original: !1,
      running: !1,
      time: !1,
      timer: !1,
      $wrapper: !1,
      constructor: function (t, i, e) {
        e || (e = {}),
          (this.lists = []),
          (this.running = !1),
          this.base(e),
          (this.$el = s(t).addClass(this.classes.wrapper)),
          (this.$wrapper = this.$el),
          (this.original = i instanceof Date ? i : i ? Math.round(i) : 0),
          (this.time = new FlipClock.Time(this, this.original, {
            minimumDigits: this.minimumDigits,
            animationRate: this.animationRate
          })),
          (this.timer = new FlipClock.Timer(this, e)),
          this.loadLanguage(this.language),
          this.loadClockFace(this.clockFace, e),
          this.autoStart && this.start();
      },
      loadClockFace: function (t, i) {
        var e,
          a = "Face",
          n = !1;
        return (
          (t = t.ucfirst() + a),
          this.face.stop && (this.stop(), (n = !0)),
          this.$el.html(""),
          (this.time.minimumDigits = this.minimumDigits),
          FlipClock[t]
            ? (e = new FlipClock[t](this, i))
            : (e = new FlipClock[this.defaultClockFace + a](this, i)),
          e.build(),
          (this.face = e),
          n && this.start(),
          this.face
        );
      },
      loadLanguage: function (t) {
        var i;
        return (
          FlipClock.Lang[t.ucfirst()]
            ? (i = FlipClock.Lang[t.ucfirst()])
            : FlipClock.Lang[t]
            ? (i = FlipClock.Lang[t])
            : (i = FlipClock.Lang[this.defaultLanguage]),
          (this.lang = i)
        );
      },
      localize: function (t, i) {
        var e = this.lang;
        if (!t) return null;
        var a = t.toLowerCase();
        return typeof i == "object" && (e = i), e && e[a] ? e[a] : t;
      },
      start: function (t) {
        var i = this;
        !i.running && (!i.countdown || (i.countdown && i.time.time > 0))
          ? (i.face.start(i.time),
            i.timer.start(function () {
              i.flip(), typeof t == "function" && t();
            }))
          : i.log("Trying to start timer when countdown already at 0");
      },
      stop: function (t) {
        this.face.stop(), this.timer.stop(t);
        for (var i in this.lists)
          this.lists.hasOwnProperty(i) && this.lists[i].stop();
      },
      reset: function (t) {
        this.timer.reset(t), this.face.reset();
      },
      setTime: function (t) {
        (this.time.time = t), this.flip(!0);
      },
      getTime: function (t) {
        return this.time;
      },
      setCountdown: function (t) {
        var i = this.running;
        (this.countdown = !!t), i && (this.stop(), this.start());
      },
      flip: function (t) {
        this.face.flip(!1, t);
      }
    });
  })(jQuery),
  (function (s) {
    "use strict";
    FlipClock.List = FlipClock.Base.extend({
      digit: 0,
      classes: {
        active: "flip-clock-active",
        before: "flip-clock-before",
        flip: "flip"
      },
      factory: !1,
      $el: !1,
      $obj: !1,
      items: [],
      lastDigit: 0,
      constructor: function (t, i, e) {
        (this.factory = t),
          (this.digit = i),
          (this.lastDigit = i),
          (this.$el = this.createList()),
          (this.$obj = this.$el),
          i > 0 && this.select(i),
          this.factory.$el.append(this.$el);
      },
      select: function (t) {
        if (
          (typeof t == "undefined" ? (t = this.digit) : (this.digit = t),
          this.digit != this.lastDigit)
        ) {
          var i = this.$el
            .find("." + this.classes.before)
            .removeClass(this.classes.before);
          this.$el
            .find("." + this.classes.active)
            .removeClass(this.classes.active)
            .addClass(this.classes.before),
            this.appendListItem(this.classes.active, this.digit),
            i.remove(),
            (this.lastDigit = this.digit);
        }
      },
      play: function () {
        this.$el.addClass(this.factory.classes.play);
      },
      stop: function () {
        var t = this;
        setTimeout(function () {
          t.$el.removeClass(t.factory.classes.play);
        }, this.factory.timer.interval);
      },
      createListItem: function (t, i) {
        return [
          '<li class="' + (t || "") + '">',
          '<a href="#">',
          '<div class="up">',
          '<div class="shadow"></div>',
          '<div class="inn">' + (i || "") + "</div>",
          "</div>",
          '<div class="down">',
          '<div class="shadow"></div>',
          '<div class="inn">' + (i || "") + "</div>",
          "</div>",
          "</a>",
          "</li>"
        ].join("");
      },
      appendListItem: function (t, i) {
        var e = this.createListItem(t, i);
        this.$el.append(e);
      },
      createList: function () {
        var t = this.getPrevDigit() ? this.getPrevDigit() : this.digit,
          i = s(
            [
              '<ul class="' +
                this.classes.flip +
                " " +
                (this.factory.running ? this.factory.classes.play : "") +
                '">',
              this.createListItem(this.classes.before, t),
              this.createListItem(this.classes.active, this.digit),
              "</ul>"
            ].join("")
          );
        return i;
      },
      getNextDigit: function () {
        return this.digit == 9 ? 0 : this.digit + 1;
      },
      getPrevDigit: function () {
        return this.digit == 0 ? 9 : this.digit - 1;
      }
    });
  })(jQuery),
  (function (s) {
    "use strict";
    (String.prototype.ucfirst = function () {
      return this.substr(0, 1).toUpperCase() + this.substr(1);
    }),
      (s.fn.FlipClock = function (t, i) {
        return new FlipClock(s(this), t, i);
      }),
      (s.fn.flipClock = function (t, i) {
        return s.fn.FlipClock(t, i);
      });
  })(jQuery),
  (function (s) {
    "use strict";
    FlipClock.Time = FlipClock.Base.extend({
      time: 0,
      factory: !1,
      minimumDigits: 0,
      constructor: function (t, i, e) {
        typeof e != "object" && (e = {}),
          e.minimumDigits || (e.minimumDigits = t.minimumDigits),
          this.base(e),
          (this.factory = t),
          i && (this.time = i);
      },
      convertDigitsToArray: function (t) {
        var i = [];
        t = t.toString();
        for (var e = 0; e < t.length; e++) t[e].match(/^\d*$/g) && i.push(t[e]);
        return i;
      },
      digit: function (t) {
        var i = this.toString(),
          e = i.length;
        return i[e - t] ? i[e - t] : !1;
      },
      digitize: function (t) {
        var i = [];
        if (
          (s.each(t, function (a, n) {
            (n = n.toString()), n.length == 1 && (n = "0" + n);
            for (var r = 0; r < n.length; r++) i.push(n.charAt(r));
          }),
          i.length > this.minimumDigits && (this.minimumDigits = i.length),
          this.minimumDigits > i.length)
        )
          for (var e = i.length; e < this.minimumDigits; e++) i.unshift("0");
        return i;
      },
      getDateObject: function () {
        return this.time instanceof Date
          ? this.time
          : new Date(new Date().getTime() + this.getTimeSeconds() * 1e3);
      },
      getDayCounter: function (t) {
        var i = [this.getDays(), this.getHours(!0), this.getMinutes(!0)];
        return t && i.push(this.getSeconds(!0)), this.digitize(i);
      },
      getDays: function (t) {
        var i = this.getTimeSeconds() / 60 / 60 / 24;
        return t && (i = i % 7), Math.floor(i);
      },
      getHourCounter: function () {
        var t = this.digitize([
          this.getHours(),
          this.getMinutes(!0),
          this.getSeconds(!0)
        ]);
        return t;
      },
      getHourly: function () {
        return this.getHourCounter();
      },
      getHours: function (t) {
        var i = this.getTimeSeconds() / 60 / 60;
        return t && (i = i % 24), Math.floor(i);
      },
      getMilitaryTime: function (t, i) {
        typeof i == "undefined" && (i = !0), t || (t = this.getDateObject());
        var e = [t.getHours(), t.getMinutes()];
        return i === !0 && e.push(t.getSeconds()), this.digitize(e);
      },
      getMinutes: function (t) {
        var i = this.getTimeSeconds() / 60;
        return t && (i = i % 60), Math.floor(i);
      },
      getMinuteCounter: function () {
        var t = this.digitize([this.getMinutes(), this.getSeconds(!0)]);
        return t;
      },
      getTimeSeconds: function (t) {
        return (
          t || (t = new Date()),
          this.time instanceof Date
            ? this.factory.countdown
              ? Math.max(this.time.getTime() / 1e3 - t.getTime() / 1e3, 0)
              : t.getTime() / 1e3 - this.time.getTime() / 1e3
            : this.time
        );
      },
      getTime: function (t, i) {
        typeof i == "undefined" && (i = !0),
          t || (t = this.getDateObject()),
          console.log(t);
        var e = t.getHours(),
          a = e > 12 ? "PM" : "AM",
          n = [e > 12 ? e - 12 : e === 0 ? 12 : e, t.getMinutes()];
        return i === !0 && n.push(t.getSeconds()), this.digitize(n);
      },
      getSeconds: function (t) {
        var i = this.getTimeSeconds();
        return t && (i == 60 ? (i = 0) : (i = i % 60)), Math.ceil(i);
      },
      getWeeks: function (t) {
        var i = this.getTimeSeconds() / 60 / 60 / 24 / 7;
        return t && (i = i % 52), Math.floor(i);
      },
      removeLeadingZeros: function (t, i) {
        var e = 0,
          a = [];
        return (
          s.each(i, function (n, r) {
            n < t ? (e += parseInt(i[n], 10)) : a.push(i[n]);
          }),
          e === 0 ? a : i
        );
      },
      addSeconds: function (t) {
        this.time instanceof Date
          ? this.time.setSeconds(this.time.getSeconds() + t)
          : (this.time += t);
      },
      addSecond: function () {
        this.addSeconds(1);
      },
      subSeconds: function (t) {
        this.time instanceof Date
          ? this.time.setSeconds(this.time.getSeconds() - t)
          : (this.time -= t);
      },
      subSecond: function () {
        this.subSeconds(1);
      },
      toString: function () {
        return this.getTimeSeconds().toString();
      }
    });
  })(jQuery),
  (function (s) {
    "use strict";
    FlipClock.Timer = FlipClock.Base.extend({
      callbacks: {
        destroy: !1,
        create: !1,
        init: !1,
        interval: !1,
        start: !1,
        stop: !1,
        reset: !1
      },
      count: 0,
      factory: !1,
      interval: 1e3,
      animationRate: 1e3,
      constructor: function (t, i) {
        this.base(i),
          (this.factory = t),
          this.callback(this.callbacks.init),
          this.callback(this.callbacks.create);
      },
      getElapsed: function () {
        return this.count * this.interval;
      },
      getElapsedTime: function () {
        return new Date(this.time + this.getElapsed());
      },
      reset: function (t) {
        clearInterval(this.timer),
          (this.count = 0),
          this._setInterval(t),
          this.callback(this.callbacks.reset);
      },
      start: function (t) {
        (this.factory.running = !0),
          this._createTimer(t),
          this.callback(this.callbacks.start);
      },
      stop: function (t) {
        (this.factory.running = !1),
          this._clearInterval(t),
          this.callback(this.callbacks.stop),
          this.callback(t);
      },
      _clearInterval: function () {
        clearInterval(this.timer);
      },
      _createTimer: function (t) {
        this._setInterval(t);
      },
      _destroyTimer: function (t) {
        this._clearInterval(),
          (this.timer = !1),
          this.callback(t),
          this.callback(this.callbacks.destroy);
      },
      _interval: function (t) {
        this.callback(this.callbacks.interval), this.callback(t), this.count++;
      },
      _setInterval: function (t) {
        var i = this;
        i._interval(t),
          (i.timer = setInterval(function () {
            i._interval(t);
          }, this.interval));
      }
    });
  })(jQuery),
  (function (s) {
    FlipClock.TwentyFourHourClockFace = FlipClock.Face.extend({
      constructor: function (t, i) {
        this.base(t, i);
      },
      build: function (a) {
        var i = this,
          e = this.factory.$el.find("ul");
        this.factory.time.time ||
          ((this.factory.original = new Date()),
          (this.factory.time = new FlipClock.Time(
            this.factory,
            this.factory.original
          )));
        var a = a || this.factory.time.getMilitaryTime(!1, this.showSeconds);
        a.length > e.length &&
          s.each(a, function (n, r) {
            i.createList(r);
          }),
          this.createDivider(),
          this.createDivider(),
          s(this.dividers[0]).insertBefore(
            this.lists[this.lists.length - 2].$el
          ),
          s(this.dividers[1]).insertBefore(
            this.lists[this.lists.length - 4].$el
          ),
          this.base();
      },
      flip: function (t, i) {
        this.autoIncrement(),
          (t = t || this.factory.time.getMilitaryTime(!1, this.showSeconds)),
          this.base(t, i);
      }
    });
  })(jQuery),
  (function (s) {
    FlipClock.CounterFace = FlipClock.Face.extend({
      shouldAutoIncrement: !1,
      constructor: function (t, i) {
        typeof i != "object" && (i = {}),
          (t.autoStart = !!i.autoStart),
          i.autoStart && (this.shouldAutoIncrement = !0),
          (t.increment = function () {
            (t.countdown = !1), t.setTime(t.getTime().getTimeSeconds() + 1);
          }),
          (t.decrement = function () {
            t.countdown = !0;
            var e = t.getTime().getTimeSeconds();
            e > 0 && t.setTime(e - 1);
          }),
          (t.setValue = function (e) {
            t.setTime(e);
          }),
          (t.setCounter = function (e) {
            t.setTime(e);
          }),
          this.base(t, i);
      },
      build: function () {
        var t = this,
          i = this.factory.$el.find("ul"),
          e = this.factory.getTime().digitize([this.factory.getTime().time]);
        e.length > i.length &&
          s.each(e, function (a, n) {
            var r = t.createList(n);
            r.select(n);
          }),
          s.each(this.lists, function (a, n) {
            n.play();
          }),
          this.base();
      },
      flip: function (t, i) {
        this.shouldAutoIncrement && this.autoIncrement(),
          t ||
            (t = this.factory
              .getTime()
              .digitize([this.factory.getTime().time])),
          this.base(t, i);
      },
      reset: function () {
        (this.factory.time = new FlipClock.Time(
          this.factory,
          this.factory.original ? Math.round(this.factory.original) : 0
        )),
          this.flip();
      }
    });
  })(jQuery),
  (function (s) {
    FlipClock.DailyCounterFace = FlipClock.Face.extend({
      showSeconds: !0,
      constructor: function (t, i) {
        this.base(t, i);
      },
      build: function (t) {
        var i = this,
          e = this.factory.$el.find("ul"),
          a = 0;
        (t = t || this.factory.time.getDayCounter(this.showSeconds)),
          t.length > e.length &&
            s.each(t, function (n, r) {
              i.createList(r);
            }),
          this.showSeconds
            ? s(this.createDivider("Seconds")).insertBefore(
                this.lists[this.lists.length - 2].$el
              )
            : (a = 2),
          s(this.createDivider("Minutes")).insertBefore(
            this.lists[this.lists.length - 4 + a].$el
          ),
          s(this.createDivider("Hours")).insertBefore(
            this.lists[this.lists.length - 6 + a].$el
          ),
          s(this.createDivider("Days", !0)).insertBefore(this.lists[0].$el),
          this.base();
      },
      flip: function (t, i) {
        t || (t = this.factory.time.getDayCounter(this.showSeconds)),
          this.autoIncrement(),
          this.base(t, i);
      }
    });
  })(jQuery),
  (function (s) {
    FlipClock.HourlyCounterFace = FlipClock.Face.extend({
      constructor: function (t, i) {
        this.base(t, i);
      },
      build: function (t, i) {
        var e = this,
          a = this.factory.$el.find("ul");
        (i = i || this.factory.time.getHourCounter()),
          i.length > a.length &&
            s.each(i, function (n, r) {
              e.createList(r);
            }),
          s(this.createDivider("Seconds")).insertBefore(
            this.lists[this.lists.length - 2].$el
          ),
          s(this.createDivider("Minutes")).insertBefore(
            this.lists[this.lists.length - 4].$el
          ),
          t ||
            s(this.createDivider("Hours", !0)).insertBefore(this.lists[0].$el),
          this.base();
      },
      flip: function (t, i) {
        t || (t = this.factory.time.getHourCounter()),
          this.autoIncrement(),
          this.base(t, i);
      },
      appendDigitToClock: function (t) {
        this.base(t), this.dividers[0].insertAfter(this.dividers[0].next());
      }
    });
  })(jQuery),
  (function (s) {
    FlipClock.MinuteCounterFace = FlipClock.HourlyCounterFace.extend({
      clearExcessDigits: !1,
      constructor: function (t, i) {
        this.base(t, i);
      },
      build: function () {
        this.base(!0, this.factory.time.getMinuteCounter());
      },
      flip: function (t, i) {
        t || (t = this.factory.time.getMinuteCounter()), this.base(t, i);
      }
    });
  })(jQuery),
  (function (s) {
    FlipClock.TwelveHourClockFace = FlipClock.TwentyFourHourClockFace.extend({
      meridium: !1,
      meridiumText: "AM",
      build: function () {
        var t = this,
          i = this.factory.time.getTime(!1, this.showSeconds);
        this.base(i),
          (this.meridiumText = this.getMeridium()),
          (this.meridium = s(
            [
              '<ul class="flip-clock-meridium">',
              "<li>",
              '<a href="#">' + this.meridiumText + "</a>",
              "</li>",
              "</ul>"
            ].join("")
          )),
          this.meridium.insertAfter(this.lists[this.lists.length - 1].$el);
      },
      flip: function (t, i) {
        this.meridiumText != this.getMeridium() &&
          ((this.meridiumText = this.getMeridium()),
          this.meridium.find("a").html(this.meridiumText)),
          this.base(this.factory.time.getTime(!1, this.showSeconds), i);
      },
      getMeridium: function () {
        return new Date().getHours() >= 12 ? "PM" : "AM";
      },
      isPM: function () {
        return this.getMeridium() == "PM";
      },
      isAM: function () {
        return this.getMeridium() == "AM";
      }
    });
  })(jQuery),
  (function (s) {
    (FlipClock.Lang.Arabic = {
      years: "\u0633\u0646\u0648\u0627\u062A",
      months: "\u0634\u0647\u0648\u0631",
      days: "\u0623\u064A\u0627\u0645",
      hours: "\u0633\u0627\u0639\u0627\u062A",
      minutes: "\u062F\u0642\u0627\u0626\u0642",
      seconds: "\u062B\u0648\u0627\u0646\u064A"
    }),
      (FlipClock.Lang.ar = FlipClock.Lang.Arabic),
      (FlipClock.Lang["ar-ar"] = FlipClock.Lang.Arabic),
      (FlipClock.Lang.arabic = FlipClock.Lang.Arabic);
  })(jQuery),
  (function (s) {
    (FlipClock.Lang.Danish = {
      years: "\xC5r",
      months: "M\xE5neder",
      days: "Dage",
      hours: "Timer",
      minutes: "Minutter",
      seconds: "Sekunder"
    }),
      (FlipClock.Lang.da = FlipClock.Lang.Danish),
      (FlipClock.Lang["da-dk"] = FlipClock.Lang.Danish),
      (FlipClock.Lang.danish = FlipClock.Lang.Danish);
  })(jQuery),
  (function (s) {
    (FlipClock.Lang.German = {
      years: "Jahre",
      months: "Monate",
      days: "Tage",
      hours: "Stunden",
      minutes: "Minuten",
      seconds: "Sekunden"
    }),
      (FlipClock.Lang.de = FlipClock.Lang.German),
      (FlipClock.Lang["de-de"] = FlipClock.Lang.German),
      (FlipClock.Lang.german = FlipClock.Lang.German);
  })(jQuery),
  (function (s) {
    (FlipClock.Lang.English = {
      years: "Years",
      months: "Months",
      days: "Days",
      hours: "Hours",
      minutes: "Minutes",
      seconds: "Seconds"
    }),
      (FlipClock.Lang.en = FlipClock.Lang.English),
      (FlipClock.Lang["en-us"] = FlipClock.Lang.English),
      (FlipClock.Lang.english = FlipClock.Lang.English);
  })(jQuery),
  (function (s) {
    (FlipClock.Lang.Spanish = {
      years: "A&#241;os",
      months: "Meses",
      days: "D&iacute;as",
      hours: "Horas",
      minutes: "Minutos",
      seconds: "Segundos"
    }),
      (FlipClock.Lang.es = FlipClock.Lang.Spanish),
      (FlipClock.Lang["es-es"] = FlipClock.Lang.Spanish),
      (FlipClock.Lang.spanish = FlipClock.Lang.Spanish);
  })(jQuery),
  (function (s) {
    (FlipClock.Lang.Finnish = {
      years: "Vuotta",
      months: "Kuukautta",
      days: "P\xE4iv\xE4\xE4",
      hours: "Tuntia",
      minutes: "Minuuttia",
      seconds: "Sekuntia"
    }),
      (FlipClock.Lang.fi = FlipClock.Lang.Finnish),
      (FlipClock.Lang["fi-fi"] = FlipClock.Lang.Finnish),
      (FlipClock.Lang.finnish = FlipClock.Lang.Finnish);
  })(jQuery),
  (function (s) {
    (FlipClock.Lang.French = {
      years: "Ans",
      months: "Mois",
      days: "Jours",
      hours: "Heures",
      minutes: "Minutes",
      seconds: "Secondes"
    }),
      (FlipClock.Lang.fr = FlipClock.Lang.French),
      (FlipClock.Lang["fr-ca"] = FlipClock.Lang.French),
      (FlipClock.Lang.french = FlipClock.Lang.French);
  })(jQuery),
  (function (s) {
    (FlipClock.Lang.Italian = {
      years: "Anni",
      months: "Mesi",
      days: "Giorni",
      hours: "Ore",
      minutes: "Minuti",
      seconds: "Secondi"
    }),
      (FlipClock.Lang.it = FlipClock.Lang.Italian),
      (FlipClock.Lang["it-it"] = FlipClock.Lang.Italian),
      (FlipClock.Lang.italian = FlipClock.Lang.Italian);
  })(jQuery),
  (function (s) {
    (FlipClock.Lang.Latvian = {
      years: "Gadi",
      months: "M\u0113ne\u0161i",
      days: "Dienas",
      hours: "Stundas",
      minutes: "Min\u016Btes",
      seconds: "Sekundes"
    }),
      (FlipClock.Lang.lv = FlipClock.Lang.Latvian),
      (FlipClock.Lang["lv-lv"] = FlipClock.Lang.Latvian),
      (FlipClock.Lang.latvian = FlipClock.Lang.Latvian);
  })(jQuery),
  (function (s) {
    (FlipClock.Lang.Dutch = {
      years: "Jaren",
      months: "Maanden",
      days: "Dagen",
      hours: "Uren",
      minutes: "Minuten",
      seconds: "Seconden"
    }),
      (FlipClock.Lang.nl = FlipClock.Lang.Dutch),
      (FlipClock.Lang["nl-be"] = FlipClock.Lang.Dutch),
      (FlipClock.Lang.dutch = FlipClock.Lang.Dutch);
  })(jQuery),
  (function (s) {
    (FlipClock.Lang.Norwegian = {
      years: "\xC5r",
      months: "M\xE5neder",
      days: "Dager",
      hours: "Timer",
      minutes: "Minutter",
      seconds: "Sekunder"
    }),
      (FlipClock.Lang.no = FlipClock.Lang.Norwegian),
      (FlipClock.Lang.nb = FlipClock.Lang.Norwegian),
      (FlipClock.Lang["no-nb"] = FlipClock.Lang.Norwegian),
      (FlipClock.Lang.norwegian = FlipClock.Lang.Norwegian);
  })(jQuery),
  (function (s) {
    (FlipClock.Lang.Portuguese = {
      years: "Anos",
      months: "Meses",
      days: "Dias",
      hours: "Horas",
      minutes: "Minutos",
      seconds: "Segundos"
    }),
      (FlipClock.Lang.pt = FlipClock.Lang.Portuguese),
      (FlipClock.Lang["pt-br"] = FlipClock.Lang.Portuguese),
      (FlipClock.Lang.portuguese = FlipClock.Lang.Portuguese);
  })(jQuery),
  (function (s) {
    (FlipClock.Lang.Russian = {
      years: "\u043B\u0435\u0442",
      months: "\u043C\u0435\u0441\u044F\u0446\u0435\u0432",
      days: "\u0434\u043D\u0435\u0439",
      hours: "\u0447\u0430\u0441\u043E\u0432",
      minutes: "\u043C\u0438\u043D\u0443\u0442",
      seconds: "\u0441\u0435\u043A\u0443\u043D\u0434"
    }),
      (FlipClock.Lang.ru = FlipClock.Lang.Russian),
      (FlipClock.Lang["ru-ru"] = FlipClock.Lang.Russian),
      (FlipClock.Lang.russian = FlipClock.Lang.Russian);
  })(jQuery),
  (function (s) {
    (FlipClock.Lang.Swedish = {
      years: "\xC5r",
      months: "M\xE5nader",
      days: "Dagar",
      hours: "Timmar",
      minutes: "Minuter",
      seconds: "Sekunder"
    }),
      (FlipClock.Lang.sv = FlipClock.Lang.Swedish),
      (FlipClock.Lang["sv-se"] = FlipClock.Lang.Swedish),
      (FlipClock.Lang.swedish = FlipClock.Lang.Swedish);
  })(jQuery);
//# sourceMappingURL=/s/files/1/2700/1230/files/flipclock.js.map?v=1679145778
